
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations directly
import enTranslation from '../public/locales/en/translation.json';
import esTranslation from '../public/locales/es/translation.json';
import frTranslation from '../public/locales/fr/translation.json';
import itTranslation from '../public/locales/it/translation.json';
import ptTranslation from '../public/locales/pt/translation.json';
import zhTranslation from '../public/locales/zh/translation.json';
import jaTranslation from '../public/locales/ja/translation.json';
import deTranslation from '../public/locales/de/translation.json';
import koTranslation from '../public/locales/ko/translation.json';
import ruTranslation from '../public/locales/ru/translation.json';

// Resources object with all translations
const resources = {
  en: { translation: enTranslation },
  es: { translation: esTranslation },
  fr: { translation: frTranslation },
  it: { translation: itTranslation },
  pt: { translation: ptTranslation },
  zh: { translation: zhTranslation },
  ja: { translation: jaTranslation },
  de: { translation: deTranslation },
  ko: { translation: koTranslation },
  ru: { translation: ruTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    
    react: {
      useSuspense: false,
    },
    
    // Force reload on every page load to ensure latest translations
    load: 'languageOnly',
    debug: false,
    
    // Add cache busting for translations
    appendNamespaceToCIMode: true,
  });

// Force re-initialization if translations were cached
if (typeof window !== 'undefined') {
  console.log('[i18n] Loaded translations version:', new Date().toISOString());
  // Force reload to pick up new translations
  i18n.reloadResources().then(() => {
    console.log('[i18n] Resources reloaded successfully');
  });
}

// Dev-time verification: ensure species & breeds keys match across locales
try {
  const locales: Record<string, any> = {
    en: enTranslation,
    es: esTranslation,
    fr: frTranslation,
    it: itTranslation,
    pt: ptTranslation,
    zh: zhTranslation,
    ja: jaTranslation,
    de: deTranslation,
    ko: koTranslation,
    ru: ruTranslation,
  };
  const base = locales.en || {};
  const baseSpecies = Object.keys(base.species || {});
  const baseBreeds = Object.keys(base.breeds || {});
  if (baseSpecies.length && baseBreeds.length) {
    console.groupCollapsed('[i18n] Species/Breeds translation verification');
    Object.entries(locales).forEach(([code, res]) => {
      const speciesKeys = Object.keys((res as any).species || {});
      const breedsKeys = Object.keys((res as any).breeds || {});
      if (speciesKeys.length === baseSpecies.length) {
        console.log(`✅ ${code}: species count ${speciesKeys.length}`);
      } else {
        const missing = baseSpecies.filter(k => !speciesKeys.includes(k));
        const extra = speciesKeys.filter(k => !baseSpecies.includes(k));
        console.warn(`❌ ${code}: species count ${speciesKeys.length} != ${baseSpecies.length}`, { missing, extra });
      }
      if (breedsKeys.length === baseBreeds.length) {
        console.log(`✅ ${code}: breeds count ${breedsKeys.length}`);
      } else {
        const missingB = baseBreeds.filter(k => !breedsKeys.includes(k));
        const extraB = breedsKeys.filter(k => !baseBreeds.includes(k));
        console.warn(`❌ ${code}: breeds count ${breedsKeys.length} != ${baseBreeds.length}`, { missing: missingB.slice(0, 30), extra: extraB.slice(0, 30) });
      }
    });
    console.groupEnd();
  } else {
    console.warn('[i18n] Skipping verification: base species/breeds keys missing');
  }
} catch (e) {
  console.warn('[i18n] Verification error', e);
}

export default i18n;
